import { CompImageUploadCore } from '../core/forms/image-upload/comp'

export const CompImageUpload = CompImageUploadCore
